import React from 'react';
import { Box, Container } from '@mui/joy';
import { AdminServiceTypes } from '../../components/congregation/AdminServiceTypes';

/**
 * Admin Service Types Management Page
 * Allows admins to manage service type master data
 */
export default function CongregationServiceTypesPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <AdminServiceTypes />
      </Box>
    </Container>
  );
}
